<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]"
  >
  <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      >
      <user-menu></user-menu>
      <template slot="links">
        <div class="">
          <sidebar-item v-if="ifAdmin" :link="{ name: 'Admin', icon: 'settings'}">
            <sidebar-item
              :link="{ name: 'Admin Portal', icon: 'dashboard', path: '/adminportal' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Add Company', icon: 'add_box', path: '/addcompany' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Add User', icon: 'library_add', path: '/adduser' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'User Lists', icon: 'library_add', path: '/users' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{ name: 'Project Portal', icon: 'dashboard', path: '/projectportal' }"
          ></sidebar-item>
          <sidebar-item v-if="gpr_access"
            :link="{ name: 'Start Project', icon: 'outlined_flag', path: '/startproject' }"
          ></sidebar-item>
          <sidebar-item
            v-if="gpr_access"
            :link="{
              name: 'Start Private Project',
              icon: 'outlined_flag',
              path: '/startprivateproject',
            }"
          ></sidebar-item>
          <li><a href="https://safecoresystems.com/schedule-work/" class="nav-link" target="_blank"><i class="md-icon md-icon-font md-theme-default">timer</i><p class="sidebar-text">Schedule Work</p></a></li>
          <sidebar-item
            :link="{ name: 'SafeCore Barcode Scanner', icon: 'scanner', path: '/scanner' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'SafeCore Guidebook', icon: 'menu_book', path: '/guidebook' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Limitations of GPR Operating in Scanned Slabs', icon: 'menu_book', path: '/limitationdoc' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'SafeCore Product Specifier', icon: 'menu_book', path: '/productspecification' }"
          ></sidebar-item>
          <div v-if="!hasCompany">
            <sidebar-item
              :link="{
                name: 'Set Company Info',
                icon: 'business',
                path: '/setcompany',
              }"
            ></sidebar-item>
          </div>
          <md-button v-if="isMobile" class="logout-mobile md-warning" @click="logoutUser">Logout</md-button>

          <!-- <sidebar-item
            :link="{ name: 'Project', icon: 'room', path: '/project' }"
          ></sidebar-item> -->
          </div>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

// function checkCompany(){
//   if (this.$store.state.company == {}){
//     this.hasCompany = false
//   } else {
//     this.hasCompany = true
//   }
// }

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import UserMenu from "./Extra/UserMenu.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
  },
  data() {
    return {
      sidebarBackgroundColor: "default",
      sidebarBackground: "default",
      sidebarMini: false,
      sidebarBackgroundImage: "",
      ifAdmin: this.$store.getters.isAdmin,
      isMobile: window.screen.width < 800 ? true : false,
      gpr_access: false
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    logoutUser(){
      this.$store
        .dispatch("signOut", {})
        .then(() => {
          this.$router.push('/portallogin')
        })
    }
  },
  computed: {
    hasCompany() {
      return this.$store.state.company
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    // console.log(this.hasCompany);
    this.gpr_access = this.$store.state.user.gpr_access;
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
    hasCompany() {
      return this.$store.state.company
    }
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.logout-mobile {
  margin-left: 30px;
}
</style>
